import type { ExerciseTotalDurationInsight } from "@tandemdiabetes/sugarmate-api-react-client"
import { useCalculationsContext } from "../CalculationsContext"
import type { TileProps } from "./TileProps"
import { TileTimeSpan } from "./TileTimeSpan"
import { TileTimeValue } from "./TileTimeValue"
import { TileTitle } from "./TileTitle"
import { usePolyglot } from "src/contexts"

export function ExerciseTotalDuration(props: TileProps<ExerciseTotalDurationInsight>) {
  const {
    insightKey,
    range,
  } = props

  const polyglot = usePolyglot()

  const { exerciseCalculations } = useCalculationsContext()
  const { totalInSeconds } = exerciseCalculations[range] || {}

  const value = totalInSeconds === undefined || isNaN(totalInSeconds)
    ? null
    : totalInSeconds / 60

  return (
    <>
      <TileTitle insightKey={insightKey} />
      <TileTimeSpan
        range={range}
        id={`${insightKey}-time-range`}
      />
      <TileTimeValue
        id={`${insightKey}-value`}
        tileId={insightKey}
        timeInMinutes={value}
        hourAbbreviation={polyglot.t("time.hour_abbreviation")}
        minuteAbbreviation={polyglot.t("time.minute_abbreviation")}
      />
    </>
  )
}
